
export const HL_YES_REGEX = /(?<=\[\[Has-Answer\]\]\s*)\s*\bYES\b/g;
export const HL_NO_REGEX = /(?<=\[\[Has-Answer\]\]\s*)\s*\bNO\b/g;
export const HL_NA_REGEX = /(?:\b|^)(N\/a)(?:\b|$)/gi;
export const HL_BRACKET_KEYWORDS_REGEX = /\[\[(Reasoning|Short-Answer|Images|Has-Answer|Links|Full-Answer)\]\]/gi;
export const HL_CUSTOM_TAGS_KEYWORDS_REGEX = /#expand|<thinking>|<\/thinking>|<reasoning>|<\/reasoning>/gi;

export const HIGLIGHT_CELL_RULES = [
    {
        highlight: HL_BRACKET_KEYWORDS_REGEX,
    },
    {
        highlight: HL_CUSTOM_TAGS_KEYWORDS_REGEX,
        className: 'hl-green'
    },
    {
        highlight: HL_YES_REGEX,
        className: 'hl-green'
    },
    {
        highlight: />>> page (?=([\d]+))/gi,
    },
    {
        highlight: />>> page ([\d]+)/gi,
        className: 'hl-green'
    },
    {
        highlight: HL_NO_REGEX,
        className: 'hl-red'
    },
    {
        highlight: HL_NA_REGEX,
        className: 'hl-grey'
    },
    {
        highlight: /\[(Source URL)\](?=\([^)]+\))/gi,
    },
    {
        highlight: /\[Source URL\]\(([^)]+)\)/gi,
        className: 'hl-green'
    },
];


export const HIGLIGHT_TOP_INSTRUCTION_RULES = [
    {
        highlight: function (str) {
            const split = '\n';
            const lines = (str || '').split(split);
            const keywords = ['#import', '#extend']; // Keywords to highlight
            const textIndexes = [];
            var nextLineIndex = 0;

            lines.forEach(line => {
                keywords.forEach(keyword => {
                    const s = line.trim().startsWith(keyword);
                    if (s) {
                        const index = line.indexOf(keyword);
                        const startIndex = nextLineIndex + index;
                        const endIndex = nextLineIndex + index + keyword.length;
                        if (startIndex !== endIndex) {
                            textIndexes.push([startIndex, endIndex]);
                        }
                    }
                });
                nextLineIndex = nextLineIndex + line.length + split.length;
            });

            return textIndexes.length > 0 ? textIndexes : false;
        },
        className: 'hl-green'
    },

    {
        highlight: function (str) {
            const split = '\n';
            const lines = (str || '').split(split);
            const keywords = ['#import ', '#extend '];
            const textIndexes = [];
            let nextLineIndex = 0;

            lines.forEach(line => {
                keywords.forEach(keyword => {
                    const keywordExists = line.trim().startsWith(keyword);
                    if (keywordExists) {
                        const index = line.indexOf(keyword);
                        let startIndex = nextLineIndex + index + keyword.length;

                        const remainingText = line.slice(index + keyword.length).trim();

                        const words = remainingText.split(/[\s,]+/);

                        words.forEach(word => {
                            const wordStartIndex = line.indexOf(word, startIndex - nextLineIndex);
                            const wordEndIndex = wordStartIndex + word.length;
                            textIndexes.push([nextLineIndex + wordStartIndex, nextLineIndex + wordEndIndex]);
                            startIndex = wordEndIndex + 1;
                        });
                    }
                });
                nextLineIndex += line.length + split.length;
            });

            return textIndexes.length > 0 ? textIndexes : false;
        }
    }

];